<template>
     <div :class="isMobile?'boxShowB':'boxShow'">
            <div :class="isMobile?'mainBoxB':'mainBox'">
                <p class="biaot">服务平台</p>
                <p class="line"></p>
                <div :class="isMobile?'powerBoxB':'powerBox'">
                    <div class="" :class="isMobile?'powerListB serverB':'powerList server'" v-for="(item,index) in serverList" :key="index" @click="jigouGoin(item.href)">
                        <img class="serverImg" :src="item.imgUrl" alt="">
                        <p class="serverName">{{ item.name }}</p>
                    </div>
                </div>
                <p class="biaot" style="margin-top: 60px;">咨询机构业务办理</p>
                <p class="line"></p>
                <div :class="isMobile?'powerBoxB':'powerBox'">
                    <div class="jigou" :class="isMobile?'powerListB':'powerList'" v-for="(item,index) in jigouList" :key="index">
                        <img class="jigouImg" :src="item.imgUrl" alt="">
                        <p class="jigouName">{{ item.name }}</p>
                        <div class="goinBtn" @click="jigouGoin(item.href)">点击进入</div>
                    </div>
                </div>
                <p class="biaot" style="margin-top: 60px;">咨询工程师业务办理</p>
                <p class="line"></p>
                <div :class="isMobile?'powerBoxB':'powerBox'">
                    <div class="jigou" :class="isMobile?'powerListB':'powerList'" v-for="(item,index) in projectList" :key="index">
                        <img class="jigouImg" :src="item.imgUrl" alt="">
                        <p class="jigouName">{{ item.name }}</p>
                        <div class="goinBtn" @click="jigouGoin(item.href)">点击进入</div>
                    </div>
                </div>
            </div>
        </div>
</template>

<script>
    export default{
        data(){
            return{
                serverList:[
                    {
                        imgUrl:require('@/assets/home/ser1.png'),
                        name:'入会申请',
                        href:'http://member.hbaec.com/Jzxh/Web/Dw/DwRegister.aspx'
                    },
                    {
                        imgUrl:require('@/assets/home/ser2.png'),
                        name:'工程咨询单位备案',
                        href:'https://new.tzxm.gov.cn/'
                    },
                    {
                        imgUrl:require('@/assets/home/ser11.png'),
                        name:'咨询专家库',
                        href:'2'
                        //href:'http://27.128.238.131:10045/'
                    },
                    {
                        imgUrl:require('@/assets/home/ser12.png'),
                        name:'会员登录',
                        href:'http://member.hbaec.com/Jzxh/Login.aspx'
                    }
                ],
                jigouList:[
                    {
                        imgUrl:require('@/assets/home/jg1.png'),
                        name:'资信评价系统',
                        href:'https://zhywglxt.cnaec.com.cn/#/consultant_login?redirect=%2F'
                    },
                    {
                        imgUrl:require('@/assets/home/jg2.png'),
                        name:'信用评价系统',
                        href:'2'
                    },
                    {
                        imgUrl:require('@/assets/home/jg3.png'),
                        name:'执业检查',
                        href:'2'
                        //href:'http://27.128.238.131:10025/zyjc/classfiy' //线上
                        // href:'http://192.168.1.56:3000/zyjc/classfiy' //本地
                    },
                    {
                        imgUrl:require('@/assets/home/jg4.png'),
                        name:'优秀成果申报',
                        href:'2'
                        //href:'http://27.128.238.131:10035/user/login' //线上
                        // href:'http://192.168.1.56:4000/user/login' //本地
                    }
                ],
                projectList:[
                {
                        imgUrl:require('@/assets/home/gc1.png'),
                        name:'考试',
                        href:'http://www.cpta.com.cn/test/1065.html'
                    },
                    {
                        imgUrl:require('@/assets/home/gc2.png'),
                        name:'登记',
                        href:'https://www.cnaec.com.cn/'
                    },
                    {
                        imgUrl:require('@/assets/home/gc3.png'),
                        name:'继续教育',
                        href:'https://zxgcsjxjy.lanmaiedu.com/index.html'
                    },
                    {
                        imgUrl:require('@/assets/home/gc4.png'),
                        name:'专业培训',
                        href:'2'
                    }
                ]
            }
        },

        methods:{
            //  服务平台/ 咨询机构业务办理 /咨询工程师业务办理
            jigouGoin(href){
                if(href==1){ //入会申请 表单填写(现在没有这个了)
                    return
                }
                if(href==2){ //功能还在研发中 
                    this.$message.info('正在研发，敬请期待')
                    return
                }
                window.open(href,'_blank')
            },
        }
    }
</script>

<style scoped>
    .boxShow{
        width: 100%;
        margin: 0 auto;
    }
    .boxShowB{
        width: 100%;
    }
    .mainBox{
        width: 1400px;
        margin: 0 auto;
        padding: 40px 0;
        background-color: #fff;
    }
    .mainBoxB{
        width: 100%;
        background-color: #fff;
        padding: 20px 0;
    }
    .biaot{
        text-align: center;
        font-size: 30px;
    }
    .line{
        width: 100px;
        height: 4px;
        background-color: #2D7CF2;
        margin: 0 auto;
        margin-top: 15px;
    }
    .powerBox{
        width: 1300px;
        margin: 0 auto;
        margin-top: 30px;
        display: flex;
        justify-content: space-between;
    }
    .powerBoxB{
        width: calc(100% - 20px);
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
    }
    .powerList{
        width: calc(25% - 40px);
    }
    .powerListB{
        width: calc(50% - 10px);
        margin-top: 20px;
    }
    .server{
        height: 310px;
        padding: 40px;
        background-color: #EDEEF2;
        border-radius: 10px;
        cursor: pointer;
    }
    .server .serverImg{
        display: block;
        width: 136px;
        margin: 0 auto;
    }
    .server .serverName{
        text-align: center;
        font-size: 20px;
        margin-top: 40px;
        font-weight: 400;
    }
    .serverB{
        padding: 15px;
        background-color: #EDEEF2;
        border-radius: 10px;
    }
    .serverB .serverImg{
        display: block;
        width: 80%;
        margin: 0 auto;
    }

    .serverB .serverName{
        text-align: center;
        font-size: 18px;
        margin-top: 20px;
        font-weight: 400;
    }
   
    .jigou{
        border-radius: 10px;
        border:1px solid #C0C0C0;
        padding-bottom: 30px;
    }
    .jigouImg{
        display: block;
        width: 100%;
        margin: 0 auto;
    }
    .jigouName{
        text-align: center;
        margin: 20px 0 20px 0;
        font-size: 20px;
        font-weight: 400;
    }
    .goinBtn{
        width: 124px;
        height: 40px;
        margin: 0 auto;
        text-align: center;
        border-radius: 3px;
        line-height: 40px;
        background-color: #327EE0;
        color: #fff;
        cursor: pointer;
    }
    .powerList:hover{
        box-shadow: 5px 5px 10px rgba(0,0,0,0.2);
    }
</style>